import config from "../config";
import { LicenseInfo, LicenseRequest } from "../Model/License";
import { sendGetRequest, sendPostRequest, sendPostRequestReturnValue } from "../Utility/FetchUtils";

export default class LicenseApi {
  static BASE_URL = config.SERVICE_URL + "/License";

  static activateManual(licenseXml: string) {
    const url = this.BASE_URL + "/manual/:activate";
    const body = {
      licenseXml: licenseXml,
    };

    return sendPostRequest(url, body);
  }

  static activateOnline(clientId: string) {
    const url = this.BASE_URL + "/online/:activate";
    const body = {
      clientId: clientId,
    };

    return sendPostRequest(url, body);
  }

  static requestManual() {
    const url = this.BASE_URL + "/manual/:request";

    return sendPostRequestReturnValue<LicenseRequest>(url);
  }

  static requestOnline() {
    const url = this.BASE_URL + "/online/:request";

    return sendPostRequest(url);
  }

  static getLicenseInfo() {
    const url = this.BASE_URL + "/info";

    return sendGetRequest<LicenseInfo>(url);
  }
}
